import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { FunnelStep } from 'src/app/domain/models/funnel/funnel-step-enum';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-upsell',
  templateUrl: './footer-upsell.component.html',
  styleUrls: ['./footer-upsell.component.scss']
})
export class FooterUpsellComponent implements OnInit {
  @Input() currentUpsellProductIndex!:number;
  @Input() FunnelFlow: FunnelFlow = { Step: FunnelStep.Upsell, UpsellsProducts: [{}] };
  @Input() showIconInc5000!: boolean;
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  public environment = environment;

  
  constructor() { }

  ngOnInit(): void {
  }

}
